import { CoursePlayerService, CourseNavigationItem } from '../../../services/course-player.service';

export function getModuleIcon(
  item: CourseNavigationItem,
  courseProgressMap: Map<string, any>,
  coursePlayerService: CoursePlayerService
): string {
  if (item.type === 'unit_intro') return 'folder';
  if (item.type === 'unit_quiz') return 'quiz';

  const progressKey = coursePlayerService.getProgressKey(item);
  const progress = courseProgressMap.get(progressKey);
  if (progress?.moduleCompleted) return 'check_circle';
  if (progress) return 'radio_button_checked';
  return 'radio_button_unchecked';
}

export function getModuleIconClass(
  item: CourseNavigationItem,
  courseProgressMap: Map<string, any>,
  coursePlayerService: CoursePlayerService
): string {
  const progressKey = coursePlayerService.getProgressKey(item);
  const progress = courseProgressMap.get(progressKey);
  if (progress?.moduleCompleted) return 'text-success';
  if (progress) return 'text-primary';
  return 'text-base-content/40';
}

export function getModuleProgress(
  moduleId: string,
  courseStructure: any,
  courseProgressMap: Map<string, any>,
  coursePlayerService: CoursePlayerService
): any {
  const item = courseStructure?.navigationItems.find((nav: CourseNavigationItem) => nav.id === moduleId);
  if (!item) {
    return courseProgressMap.get(moduleId);
  }
  const progressKey = coursePlayerService.getProgressKey(item);
  return courseProgressMap.get(progressKey);
}

export function isModuleComplete(
  moduleId: string,
  courseStructure: any,
  courseProgressMap: Map<string, any>,
  coursePlayerService: CoursePlayerService
): boolean {
  const progress = getModuleProgress(moduleId, courseStructure, courseProgressMap, coursePlayerService);
  return progress?.moduleCompleted || false;
}

export function countItemsOfType(
  courseStructure: any,
  type: 'module' | 'unit_intro'
): number {
  if (!courseStructure) return 0;
  return courseStructure.navigationItems.filter((item: CourseNavigationItem) => item.type === type).length;
}

export function getUnitStatsForItem(
  currentItem: CourseNavigationItem | null,
  courseStructure: any
): { totalModules: number; hasUnitQuiz: boolean } | null {
  if (!currentItem || !courseStructure || currentItem.type !== 'unit_intro') {
    return null;
  }
  const unitItems = courseStructure.navigationItems.filter(
    (item: CourseNavigationItem) => item.parentUnitId === currentItem.parentUnitId
  );
  return {
    totalModules: unitItems.filter((item: CourseNavigationItem) => item.type === 'module').length,
    hasUnitQuiz: unitItems.some((item: CourseNavigationItem) => item.type === 'unit_quiz'),
  };
}
